module.exports = __webpack_public_path__ + "static/media/fasket.47bbcdff.png";